export default __webpack_public_path__ + "static/media/landing-tesla.700f2bc6.png";